import { render, staticRenderFns } from "./xieyi1.vue?vue&type=template&id=e0bff008&scoped=true&"
import script from "./xieyi1.vue?vue&type=script&lang=js&"
export * from "./xieyi1.vue?vue&type=script&lang=js&"
import style0 from "./xieyi1.vue?vue&type=style&index=0&id=e0bff008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bff008",
  null
  
)

export default component.exports